import { ApiRoutes } from "../common/apiRoutes";
import Http from "../services/http";

export const getCouponsAPI = (sort_by:any,sort_direction:any) => {
  return Http.get(`coupon?sort_by=${sort_by}&sort_direction=${sort_direction}`);
};
export const addCouponsAPI = (data:any) => {
  return Http.post(ApiRoutes.addCoupons,data);
};
export const getCouponsDetailsAPI = (id:any) => {
  return Http.get(`coupon/${id}`);
};
export const editCouponsAPI = (id:any,data:any) => {
  return Http.put(`coupon/${id}`,data);
};

export const deleteCouponsAPI = (id:any) => {
  return Http.delete(`coupon/${id}`);
};